import { stripLeadingSlash, stripTrailingSlash } from '../../lib/urlUtil';
import { Cloud$Market } from '../../types/cloudEnums';
import { Otovo$Locale } from '../../types/otovoweb';
import { getURLConfigForPath } from '../Navigation/localizedSanityPaths';

type Args = {
  nextPath: string;
  baseUrl: string;
  market: Cloud$Market;
  locale: Otovo$Locale;
  isMultiLocaleBu: boolean;
};

export function getCanonicalUrl({
  nextPath,
  baseUrl,
  market,
  locale,
  isMultiLocaleBu,
}: Args): string {
  // Next router sometimes sets asPath to '//' for index pages.
  // Get rid of any repeated trailing slash paths.
  let path = nextPath.replace(/\/+/g, '/');

  if (path === '') {
    path = '/';
  }

  if (!baseUrl) {
    return path;
  }

  if (path === '/') {
    if (isMultiLocaleBu) {
      return `${baseUrl}/${locale}/`;
    }
    return `${baseUrl}/`;
  }

  const urlConfig = getURLConfigForPath(path, market, locale);

  if (urlConfig) {
    path = path.replace(urlConfig.nextPath, urlConfig.localizedPath);
  }

  path = stripLeadingSlash(path);

  if (isMultiLocaleBu) {
    return [stripTrailingSlash(baseUrl), locale, path].join('/');
  }

  return [stripTrailingSlash(baseUrl), path].join('/');
}
